import { render, staticRenderFns } from "./conferenceAll.vue?vue&type=template&id=33227b8f"
import script from "./conferenceAll.vue?vue&type=script&lang=js"
export * from "./conferenceAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports